{
  "enum": {
    "ExcQuotemediaV1EodPriceJobStatus": {
      "DONE": "Done",
      "PROCESSING": "Processing",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcQuotemediaV1EodPriceTaskStatus": {
      "ERRORED": "Errored",
      "FAILED": "Failed",
      "PENDING": "Pending",
      "SUCCEEDED": "Succeeded",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcQuotemediaV1Sp500ListStatus": {
      "ACTIVE": "Active",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcQuotemediaV1Sp500ListSummaryName": {
      "Sp500ListSummary": "S&P 500 List Summary",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "ExcQuotemediaV1EodPriceJobQueryServiceEodPriceJobListFilterableFields": {
      "jobId": "Job",
      "status": "Status"
    },
    "ExcQuotemediaV1EodPriceTaskQueryServiceEodPriceTaskListFilterableFields": {
      "jobId": "Job",
      "status": "Status",
      "taskId": "Task"
    },
    "ExcQuotemediaV1Sp500ListQueryServiceSp500ListListFilterableFields": {
      "quarter": "Quarter",
      "status": "Status"
    }
  },
  "oneOf": {
    "ExcQuotemediaV1EodPriceJobEventType": {
      "allFinished": "All Finished",
      "created": "Created",
      "taskUpdated": "Task Updated"
    },
    "ExcQuotemediaV1EodPriceTaskEventType": {
      "created": "Created",
      "errored": "Errored",
      "failed": "Failed",
      "finished": "Finished"
    },
    "ExcQuotemediaV1Sp500ListEventType": {
      "assetLinked": "Asset Linked",
      "created": "Created"
    }
  },
  "sortEnum": {
    "ExcQuotemediaV1EodPriceJobQueryServiceEodPriceJobListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "ExcQuotemediaV1EodPriceTaskQueryServiceEodPriceTaskListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "ExcQuotemediaV1Sp500ListQueryServiceSp500ListListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}